module.exports = require("./ia.js");